let swatches = document.querySelectorAll('.featured-product .color-swatch');
let swatchesLength = swatches.length;
let swatchNumber = document.querySelectorAll('.featured-product .color-swatch--more');

swatches.forEach(swatch => {
    let index = swatch.getAttribute('index');
    if(index > 2){
        swatch.classList.add('hidden');
        swatchNumber[0].innerHTML = `+${swatchesLength - 4}`;
        swatchNumber[0].style.display = 'flex';
    }
});

swatchNumber[0].addEventListener('click', () => {
    swatches.forEach(swatch => {
        swatch.classList.remove('hidden');
    });
    swatchNumber[0].classList.add('hidden');
});